import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Row,
  CardGroup,
  Alert,
} from "reactstrap";
import * as API_LINKS from "../../../redux/config/links.jsx";
import logoAutoma from "../../../assets/img/brand/new-automa-logo.png";
import { HashLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";
import HorizontalButtonSlider from "../../../components/HorizontalButtonSlider/index.jsx";

const optionsParent = {
  defaultSortName: "id", // default sort column name
  defaultSortOrder: "asc", // default sort order
  noDataText: "No place registered on your dashboard. Try one-lah!",
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ],
  sizePerPage: 20,
  exportCSVSeparator: ";",
};
const options = {
  defaultSortName: "id", // default sort column name
  defaultSortOrder: "asc", // default sort order
  noDataText: "No place registered on your dashboard. Try one-lah!",
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ],
  sizePerPage: 10,
  exportCSVSeparator: ";",
};

const OpnameTaskExecution = ({ ...props }) => {
  const { key, id } = props.match.params;
  // let { key } = useParams();
  const numberToLetter = (number) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";

    while (number > 0) {
      const remainder = (number - 1) % 26;
      result = letters[remainder] + result;
      number = Math.floor((number - 1) / 26);
    }

    return result;
  };

  const numberToRoman = (number) => {
    const romanNumerals = {
      1000: "M",
      900: "CM",
      500: "D",
      400: "CD",
      100: "C",
      90: "XC",
      50: "L",
      40: "XL",
      10: "X",
      9: "IX",
      5: "V",
      4: "IV",
      1: "I",
    };

    let result = "";

    const sortedValues = Object.keys(romanNumerals)
      .map((value) => Number(value))
      .sort((a, b) => b - a);

    for (let value of sortedValues) {
      while (number >= value) {
        result += romanNumerals[value];
        number -= value;
      }
    }

    return result;
  };

  const [isFetching, setIsFetching] = useState(true);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);
  const [isLoadingOpname, setIsLoadingOpname] = useState(false);
  const [data, setData] = useState(null);
  const [opname, setOpname] = useState(null);
  const [editCount, setEditCount] = useState([]);
  // const [modalAdd, setModalAdd] = useState(false);
  // const [modalDelete, setModalDelete] = useState(false);
  // const [modalEdit, setModalEdit] = useState(false);

  const updateYear = () => {
    var d = new Date();
    var n = d.getFullYear();
    return n;
  };
  const fileNameFormat = () => {
    var baseName = "Driver App User - ";
    var baseDate = new Date();
    var date = moment(baseDate).format("DD-MMM-YYYY HH:mm");
    var strDate = date.toString();
    return baseName + strDate + ".csv";
  };

  const getOpname = useCallback(() => {
    setIsLoadingOpname(true);
    const fd = new FormData();
    fd.append("id", id);
    fetch(API_LINKS.OPNAME_LIST, {
      method: "post",
      body: fd,
      headers: {
        Authorization: key,
      },
    }).then((res) => {
      setIsLoadingOpname(false);
      if (res.status >= 200 && res.status < 300) {
        res.json().then((result) => {
          if (result.result && result.result.length > 0) {
            setOpname(result.result[0]);
          }
        });
      }
    });
  }, [API_LINKS, id, key]);

  const getOrder = useCallback(() => {
    const fd = new FormData();
    fd.append("id_opname_task_order", id);
    fetch(API_LINKS.OPNAME_ORDER_DETAIL_LIST, {
      method: "post",
      body: fd,
      headers: {
        Authorization: key,
      },
    }).then((res) => {
      setIsLoadingOrder(false);
      if (res.status >= 200 && res.status < 300) {
        res.json().then((result) => {
          setEditCount([
            ...(result ? result.result : []).map((item) => ({
              id: item.id,
              qty_result_count: item.qty_result_count,
              isLoading: false,
            })),
          ]);
          setData({
            ...result,
          });
        });
      }
    });
  }, [API_LINKS, key, id]);

  const onSubmitEdit = (value) => {
    setEditCount([
      ...editCount.map((item) =>
        value.id === item.id
          ? {
              ...item,
              isLoading: true,
            }
          : item
      ),
    ]);

    const fd = new FormData();
    fd.append("id", value.id);
    fd.append("qty_result_count", value.qty_result_count);
    fetch(API_LINKS.OPNAME_ORDER_DETAIL_EDIT, {
      method: "post",
      body: fd,
      headers: {
        Authorization: key,
      },
    }).then((res) => {
      setEditCount([
        ...editCount.map((item) =>
          value.id === item.id
            ? {
                ...item,
                isLoading: false,
              }
            : item
        ),
      ]);
      if (res.status >= 200 && res.status < 300) {
        toast.success("Successfully saved!");
        console.log("yoo");
        res.json().then((result) => {
          setEditCount([
            ...editCount.map((item) =>
              value.id === item.id
                ? {
                    ...value,
                    isLoading: false,
                  }
                : item
            ),
          ]);

          setData({
            result: [
              ...data.result.map((item) => ({
                ...(item.id === value.id
                  ? { ...item, qty_result_count: value.qty_result_count }
                  : item),
              })),
            ],
          });
        });
      } else {
        toast.error("Something went wrong!");
      }
    });
  };

  useEffect(() => {
    if (isSubmiting) {
      setIsSubmiting(false);
      setIsLoadingSubmit(true);
      const fd = new FormData();
      fd.append("id", id);
      fd.append("status", 3);
      fetch(API_LINKS.OPNAME_EDIT, {
        method: "post",
        body: fd,
        headers: {
          Authorization: key,
        },
      })
        .then((res) => {
          setIsLoadingSubmit(false);
          if (res.status >= 200 && res.status < 300) {
            setIsFetching(true);
            toast.success("Successfully submited!");
          } else {
            toast.error("Something went wrong!");
          }
        })
        .catch(() => {
          setIsLoadingSubmit(false);
          toast.error("Something went wrong!");
        });
    }
  }, [isSubmiting, API_LINKS, id, key, toast]);

  const onSubmit = (value) => {
    if (value === 100) {
      setIsSubmiting(true);
    }
  };

  useEffect(() => {
    if (isFetching) {
      setIsFetching(false);
      setIsLoadingOrder(true);
      getOrder();
      getOpname();
    }
  }, [isFetching, getOrder, getOpname]);

  return (
    <div className="container-responsive">
      <CardGroup>
        <Card className="p-4">
          <CardBody>
            <img
              src={logoAutoma}
              alt="Automa Logo"
              className="automa-logo-login"
              style={{ maxWidth: "5em", height: "auto", width: "4em" }}
            />
            <br />
            <br />
            {isLoadingOrder || isLoadingOpname ? (
              <center>
                <HashLoader color={"#123abc"} loading={true} /> <br />{" "}
                Loading.... Please wait...
              </center>
            ) : (
              <React.Fragment>
                <h4>
                  Opname: {opname ? opname.opname_name : null}{" "}
                  {opname ? (
                    opname.status.status >= 3 ? (
                      <i
                        className="fa fa-check-circle"
                        style={{ color: "#28a745" }}
                      ></i>
                    ) : null
                  ) : null}
                </h4>
                <br />
                <Card>
                  {/* <Alert color="primary" style={{ marginBottom: 0 }}>
                          Courier is delivering your package.
                        </Alert> */}
                  {opname ? (
                    <Alert color="success">
                      <Row>
                        <Col md="6">
                          <dt>Created By</dt>
                          <dd>{opname.created_by_data.full_name}</dd>
                          <dt>Task By</dt>
                          <dd>{opname.task_by_data.full_name}</dd>
                        </Col>
                        <Col md="6">
                          <dt>Opname</dt>
                          <dd>{opname.scope_opname.name}</dd>
                          <dt>Created On</dt>
                          <dd>{opname.created_on}</dd>
                        </Col>
                      </Row>
                    </Alert>
                  ) : null}
                  {data ? (
                    <React.Fragment>
                      <Row className="container">
                        <Col md="6">
                          <dt>Total semua Item</dt>
                          <dd>{(data ? data.result : []).length}</dd>

                          <dt>Total Item yang sudah diisi</dt>
                          <dd>
                            {(data ? data.result : []).reduce(
                              (accumulator, object) => {
                                return (
                                  accumulator +
                                  (object.qty_target !== null &&
                                  object.qty_target > 0
                                    ? 1
                                    : 0)
                                );
                              },
                              0
                            )}
                          </dd>
                        </Col>
                        <Col md="6">
                          <dt>Total Item yang belum diisi</dt>
                          <dd>
                            {(data ? data.result : []).reduce(
                              (accumulator, object) => {
                                return (
                                  accumulator +
                                  (object.qty_target === null ||
                                  object.qty_target <= 0
                                    ? 1
                                    : 0)
                                );
                              },
                              0
                            )}
                          </dd>
                        </Col>
                      </Row>
                      <Row>
                        {opname && opname.status.status < 3 ? (
                          <Col className={"pull-right text-right offset-md-9"}>
                            <HorizontalButtonSlider
                              buttonText={
                                <React.Fragment>
                                  <i className="fa fa-plus"></i>&nbsp;Submit
                                </React.Fragment>
                              }
                              onAfterChange={(value) => onSubmit(value)}
                            />
                            {isLoadingSubmit ? (
                              <center>
                                <HashLoader color={"#123abc"} loading={true} />{" "}
                                <br /> Loading.... Please wait...
                              </center>
                            ) : null}
                          </Col>
                        ) : null}
                      </Row>
                      <Row>
                        <Col md="12">
                          <React.Fragment>
                            <dt></dt>
                            <dd>
                              <BootstrapTable
                                data={(data ? data.result : []).filter(
                                  (item, index, self) => {
                                    return (
                                      self.findIndex(
                                        (selfItem) =>
                                          item.id_warehouse_actual ===
                                          selfItem.id_warehouse_actual
                                      ) === index
                                    );
                                  }
                                )}
                                version="4"
                                edit
                                options={optionsParent}
                                csvFileName={fileNameFormat}
                                multiColumnSearch
                                expandableRow={() => true}
                                expandComponent={(row) => (
                                  <BootstrapTable
                                    data={(data ? data.result : [])
                                      .filter(
                                        (item) =>
                                          item.id_warehouse_actual ===
                                          row.id_warehouse_actual
                                      )
                                      .filter((item, index, self) => {
                                        return (
                                          self.findIndex(
                                            (selfItem) =>
                                              item.id_warehouse_area_actual ===
                                              selfItem.id_warehouse_area_actual
                                          ) === index
                                        );
                                      })}
                                    version="4"
                                    edit
                                    options={optionsParent}
                                    csvFileName={fileNameFormat}
                                    multiColumnSearch
                                    expandableRow={() => true}
                                    expandComponent={(row) => (
                                      <BootstrapTable
                                        data={(data ? data.result : [])
                                          .filter(
                                            (item) =>
                                              item.id_warehouse_actual ===
                                                row.id_warehouse_actual &&
                                              item.id_warehouse_area_actual ===
                                                row.id_warehouse_area_actual
                                          )
                                          .filter((item, index, self) => {
                                            return (
                                              self.findIndex(
                                                (selfItem) =>
                                                  item.id_rack_actual ===
                                                  selfItem.id_rack_actual
                                              ) === index
                                            );
                                          })}
                                        version="4"
                                        edit
                                        options={optionsParent}
                                        csvFileName={fileNameFormat}
                                        multiColumnSearch
                                        expandableRow={() => true}
                                        expandComponent={(row) => (
                                          <BootstrapTable
                                            data={(data
                                              ? data.result
                                              : []
                                            ).filter(
                                              (item) =>
                                                item.id_warehouse_actual ===
                                                  row.id_warehouse_actual &&
                                                item.id_warehouse_area_actual ===
                                                  row.id_warehouse_area_actual &&
                                                item.id_rack_actual ===
                                                  row.id_rack_actual
                                            )}
                                            version="4"
                                            striped
                                            hover
                                            pagination
                                            search
                                            edit
                                            options={options}
                                            exportCSV={true}
                                            csvFileName={fileNameFormat}
                                            multiColumnSearch
                                            expandableRow={() => true}
                                            expandComponent={(row) => (
                                              <React.Fragment>
                                                <Row>
                                                  <Col md="4">
                                                    <dt>Item Name</dt>
                                                    <dd>
                                                      {row.master_item_name}
                                                    </dd>
                                                    <dt>Brand</dt>
                                                    <dd>-</dd>
                                                  </Col>
                                                  <Col md="4">
                                                    <dt>SKU Item Name</dt>
                                                    <dd>{row.sku_name}</dd>
                                                    <dt>SKU Item Code</dt>
                                                    <dd>{row.sku_code}</dd>
                                                  </Col>
                                                  <Col md="4">
                                                    <dt>Matrix</dt>
                                                    <dd>
                                                      {row.x_actual
                                                        ? numberToLetter(
                                                            row.x_actual
                                                          )
                                                        : "-"}{" "}
                                                      /{" "}
                                                      {row.y_actual
                                                        ? row.y_actual
                                                        : "-"}{" "}
                                                      /{" "}
                                                      {row.z_actual
                                                        ? numberToRoman(
                                                            row.z_actual
                                                          )
                                                        : "-"}
                                                    </dd>
                                                    <dt>Opname Stock</dt>
                                                    <dd>
                                                      <Row>
                                                        <div
                                                          className={"col-7"}
                                                        >
                                                          {editCount.filter(
                                                            (item) =>
                                                              item.id === row.id
                                                          ).length > 0 ? (
                                                            <Input
                                                              size="sm"
                                                              disabled={
                                                                editCount.filter(
                                                                  (item) =>
                                                                    item.id ===
                                                                    row.id
                                                                )[0]
                                                                  .isLoading ||
                                                                row.qty_result_count !==
                                                                  null
                                                              }
                                                              value={
                                                                editCount.filter(
                                                                  (item) =>
                                                                    item.id ===
                                                                    row.id
                                                                )[0]
                                                                  .qty_result_count
                                                              }
                                                              onChange={(e) =>
                                                                setEditCount([
                                                                  ...editCount.map(
                                                                    (item) =>
                                                                      item.id ===
                                                                      row.id
                                                                        ? {
                                                                            ...item,
                                                                            qty_result_count:
                                                                              e
                                                                                .currentTarget
                                                                                .value,
                                                                          }
                                                                        : item
                                                                  ),
                                                                ])
                                                              }
                                                              type="text"
                                                              name="opname_stock"
                                                              id="opname_stock"
                                                              placeholder="Opname Stock"
                                                              autoComplete="off"
                                                            />
                                                          ) : null}
                                                        </div>
                                                        <div className="col-5">
                                                          {row.qty_result_count !==
                                                          null ? null : (
                                                            <Button
                                                              size="sm"
                                                              disabled={
                                                                editCount.filter(
                                                                  (item) =>
                                                                    item.id ===
                                                                    row.id
                                                                )[0].isLoading
                                                              }
                                                              onClick={() => {
                                                                return onSubmitEdit(
                                                                  editCount.filter(
                                                                    (item) =>
                                                                      item.id ===
                                                                      row.id
                                                                  )[0]
                                                                );
                                                              }}
                                                              color="primary"
                                                            >
                                                              <i
                                                                className="fa fa-floppy-o"
                                                                aria-hidden="true"
                                                              ></i>
                                                            </Button>
                                                          )}
                                                        </div>
                                                      </Row>
                                                    </dd>
                                                  </Col>
                                                </Row>
                                              </React.Fragment>
                                            )}
                                            expandColumnOptions={{
                                              expandColumnVisible: true,
                                            }}
                                          >
                                            <TableHeaderColumn
                                              dataField="id"
                                              isKey
                                              csvHeader="ID"
                                              hidden
                                            >
                                              ID
                                            </TableHeaderColumn>
                                            <TableHeaderColumn
                                              dataField="master_item_name"
                                              searchable
                                              csvHeader="Name"
                                              thStyle={{
                                                whiteSpace: "normal",
                                              }}
                                              tdStyle={{
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              Item Name
                                            </TableHeaderColumn>
                                          </BootstrapTable>
                                        )}
                                        expandColumnOptions={{
                                          expandColumnVisible: true,
                                        }}
                                      >
                                        <TableHeaderColumn
                                          dataField="id"
                                          isKey
                                          csvHeader="ID"
                                          hidden
                                        >
                                          ID
                                        </TableHeaderColumn>

                                        <TableHeaderColumn
                                          dataField="rack_name"
                                          searchable
                                          csvHeader="rack"
                                          thStyle={{
                                            whiteSpace: "normal",
                                          }}
                                          tdStyle={{
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          Rack
                                        </TableHeaderColumn>
                                      </BootstrapTable>
                                    )}
                                    expandColumnOptions={{
                                      expandColumnVisible: true,
                                    }}
                                  >
                                    <TableHeaderColumn
                                      dataField="id"
                                      isKey
                                      csvHeader="ID"
                                      hidden
                                    >
                                      ID
                                    </TableHeaderColumn>

                                    <TableHeaderColumn
                                      dataField="area_name"
                                      searchable
                                      csvHeader="area_name"
                                      thStyle={{ whiteSpace: "normal" }}
                                      tdStyle={{ whiteSpace: "normal" }}
                                    >
                                      Warehouse Area
                                    </TableHeaderColumn>
                                  </BootstrapTable>
                                )}
                                expandColumnOptions={{
                                  expandColumnVisible: true,
                                }}
                              >
                                <TableHeaderColumn
                                  dataField="id"
                                  isKey
                                  csvHeader="ID"
                                  hidden
                                >
                                  ID
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                  dataField="warehouse_name"
                                  searchable
                                  csvHeader="warehouse_name"
                                  thStyle={{
                                    whiteSpace: "normal",
                                  }}
                                  tdStyle={{
                                    whiteSpace: "normal",
                                  }}
                                >
                                  Warehouse
                                </TableHeaderColumn>
                              </BootstrapTable>
                            </dd>
                          </React.Fragment>
                        </Col>
                      </Row>
                    </React.Fragment>
                  ) : null}
                  <br />
                </Card>
              </React.Fragment>
            )}
          </CardBody>
          <Row>
            <Col md="12">
              <span className="pull-right">
                <a href="https://automa.id">Automa</a> &copy; {updateYear()}
              </span>
            </Col>
          </Row>
        </Card>
      </CardGroup>
      <ToastContainer
        position="bottom-right"
        autoClose={7300}
        style={{ zIndex: 7000 }}
      />
    </div>
  );
};

export default OpnameTaskExecution;



// WEBPACK FOOTER //
// ./src/views/Opname/OpnameTaskExecution/OpnameTaskExecution.jsx